module.exports = __webpack_public_path__ + "static/media/la.1d965d20.jpg";